/** Legacy Alert Settings labels → current display labels (saved preferences migration). */
export const ALERT_CATEGORY_LEGACY_ALIASES = {
  'Cloud Services': 'Cloud Services (Education only)',
  'IT Hardware': 'IT Hardware (Education only)',
  'IT Services': 'IT Services (Education only)',
  'Lab Equipment': 'Lab Equipment (Education only)',
  'Website Development': 'Website Development (Education only)',
  'Online Assessment & e-Exam Platforms': 'Online Exam Platforms',
  'Course & Teaching Evaluation': 'Feedback & Evaluation',
};

/** Alert Settings labels removed from the picker (stripped on load/save). */
export const REMOVED_ALERT_CATEGORIES = new Set([
  'Other',
  'Digital Collections & Digitization Services',
  'Digital Content Subscriptions (of all types)',
]);

/**
 * Alert Settings display labels → deal/API category strings used when filtering live deals.
 */
export const ALERT_CATEGORY_TO_DEAL_NAMES = {
  'Cloud Services (Education only)': ['Cloud Services'],
  'IT Hardware (Education only)': ['IT Hardware'],
  'IT Services (Education only)': ['IT Services'],
  'Lab Equipment (Education only)': ['Lab Equipment'],
  'Website Development (Education only)': ['Website Development'],
  'Online Exam Platforms': ['Online Exam Platforms', 'Online Assessment & e-Exam Platforms'],
  'Feedback & Evaluation': [
    'Feedback & Evaluation',
    'Course & Teaching Evaluation',
    'course_evaluation',
  ],
};

export function normalizeLiveDealCategories(categories) {
  if (!Array.isArray(categories)) return [];
  const out = [];
  const seen = new Set();
  for (const raw of categories) {
    const c = ALERT_CATEGORY_LEGACY_ALIASES[raw] ?? raw;
    if (!c || REMOVED_ALERT_CATEGORIES.has(c) || seen.has(c)) continue;
    seen.add(c);
    out.push(c);
  }
  return out;
}

/** Expand alert preference labels so deal filters still match procurement category strings. */
export function expandAlertCategoriesForMatching(categories) {
  const out = new Set();
  for (const c of normalizeLiveDealCategories(categories)) {
    out.add(c);
    const dealNames = ALERT_CATEGORY_TO_DEAL_NAMES[c];
    if (dealNames) dealNames.forEach((n) => out.add(n));
  }
  return [...out];
}
